import type { IThread } from '@/types';

export const getNextVisibleThread = (
  visibleThreads: IThread[],
  movedThreadId: string,
): IThread | undefined => {
  const currentIndex = visibleThreads.findIndex((thread) => thread.threadId === movedThreadId);
  if (currentIndex < 0) return undefined;
  const remaining = visibleThreads.filter((thread) => thread.threadId !== movedThreadId);
  return remaining[Math.min(currentIndex, remaining.length - 1)];
};

export const restoreThreadAtIndex = (
  threads: IThread[],
  thread: IThread,
  originalIndex: number,
): IThread[] => {
  const restored = threads.filter((item) => item.threadId !== thread.threadId);
  restored.splice(Math.min(Math.max(originalIndex, 0), restored.length), 0, thread);
  return restored;
};
